import { Box, Container, Spinner } from "@sembark-travel/ui/base"
import { Helmet } from "react-helmet-async"
import { EditUserRolesForm, IUser, UsersXHR } from "./../../../../Users"
import { LoaderFunctionArgs, useLoaderData, Await } from "react-router"
import { xhr } from "@sembark-travel/xhr"
import { Breadcrumbs } from "@sembark-travel/ui/router"
import { generatePath, redirect, useNavigate } from "../../../../router-utils"
import { Suspense } from "react"

export async function Loader({ params }: LoaderFunctionArgs) {
	if (!params.userId) {
		return redirect("/org/users")
	}
	const user = UsersXHR(xhr).getUser(params.userId)
	return { user }
}

export default function EditUserRoles() {
	const navigate = useNavigate()
	const { user } = useLoaderData() as { user: Promise<IUser> }
	return (
		<>
			<Helmet>
				<title>Edit User's Roles</title>
			</Helmet>
			<Suspense fallback={<Spinner padding="4" alignCenter />}>
				<Await resolve={user}>
					{(user: IUser) => (
						<>
							<Breadcrumbs
								title="Edit User's Role"
								items={[
									[generatePath("/org/users"), "Users"],
									[
										generatePath("/users/:userId", {
											userId: user.id.toString(),
										}),
										user.name,
									],
									["", "Edit Role"],
								]}
							/>
							<Box paddingX="4" paddingY="8">
								<Box maxWidth="xl" marginX="auto">
									<Box borderWidth="1" rounded="md" bgColor="default">
										<Container paddingY="6">
											<EditUserRolesForm
												user={user}
												onSuccess={() =>
													navigate("/users/:userId", {
														params: { userId: user.id.toString() },
													})
												}
												onCancel={() =>
													navigate("/users/:userId", {
														params: { userId: user.id.toString() },
													})
												}
											/>
										</Container>
									</Box>
								</Box>
							</Box>
						</>
					)}
				</Await>
			</Suspense>
		</>
	)
}
